export const DOCUMENTS = 1;
export const DOCUMENT_LIBRARY = 2;
export const DOCUMENT_LIBRARY_FOR_BRANCH = 3; 

export default {
  DOCUMENTS,
  DOCUMENT_LIBRARY,
  DOCUMENT_LIBRARY_FOR_BRANCH
};
